<div class="horizontal-menu">
  <nav class="navbar top-navbar col-lg-12 col-12 p-0">
    <div class="container-fluid">
      <div
        class="navbar-menu-wrapper d-flex align-items-center justify-content-between"
      >
        <div
          class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center"
        >
          <a class="navbar-brand brand-logo"
            ><img src="assets/images/logo.png"
          /></a>
          <a class="navbar-brand brand-logo-mini"
            ><img src="assets/images/logo.png"
          /></a>
        </div>
        <!-- <div class="wlmessage">
          <h1 class="text-uppercase">Welcome {{user}}</h1>
        </div> -->

        <ul class="navbar-nav navbar-nav-right">
          <li class="nav-item nav-profile dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              data-toggle="dropdown"
              id="profileDropdown"
              role="button"
            >
              <span class="nav-profile-name">{{user}}</span>
              <span class="online-status"></span>
            </a>
            <div
              class="dropdown-menu dropdown-menu-right navbar-dropdown"
              aria-labelledby="profileDropdown"
            >
              <a
                class="dropdown-item"
                (click)="router.navigate(['administrator'])"
              >
                <i class="mdi mdi-account-key text-primary"></i>
                Administrator
              </a>
              <a class="dropdown-item" (click)="logout()">
                <i class="mdi mdi-logout text-primary"></i>
                Logout
              </a>
            </div>
          </li>
        </ul>
        <button
          class="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
          type="button"
          data-toggle="horizontal-menu-toggle"
          (click)="toggleCollapsed()"
        >
          <span class="mdi mdi-menu"></span>
        </button>
      </div>
    </div>
  </nav>
  <nav [ngClass]="{'header-toggled' : collapsed, 'bottom-navbar': true}">
    <div class="container">
      <ul class="nav page-navigation">
        <li class="nav-item">
          <a (click)="router.navigate(['dashboard'])" class="nav-link">
            <i class="mdi mdi-view-dashboard menu-icon"></i>
            <span class="menu-title">Dashboard</span></a
          >
        </li>
        <li
          (click)="toggleSubmenuMasters()"
          [ngClass]="{'show-submenu' : submenuMasters, 'nav-item': true}"
        >
          <a class="nav-link">
            <i class="mdi mdi-source-branch menu-icon"></i>
            <span class="menu-title">Masters</span>
            <i class="menu-arrow"></i>
          </a>
          <div class="submenu">
            <ul>
              <li class="nav-item">
                <a
                  class="nav-link"
                  (click)="router.navigate(['masters/ProcessMaster'])"
                  >Process</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  (click)="router.navigate(['masters/ProcessToSkillLevelMaster'])"
                  >Skill Level</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  (click)="router.navigate(['masters/CustomerMaster'])"
                  >Customer</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  (click)="router.navigate(['masters/DepartmentMaster'])"
                  >Department</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  (click)="router.navigate(['masters/employeeMaster'])"
                  >Employee Master</a
                >
              </li>
              <!-- <li class="nav-item">
                <a
                  class="nav-link"
                  (click)="router.navigate(['masters/StudyMaterialMaster'])"
                  >Study Material</a
                >
              </li> -->

              <li class="nav-item">
                <a
                  class="nav-link"
                  (click)="router.navigate(['masters/TrainingProgramMaster'])"
                  >Training Program</a
                >
              </li>
            </ul>
          </div>
        </li>

        <li
          (click)="toggleSubmenuTransactions()"
          [ngClass]="{'show-submenu' : submenuTransactions, 'nav-item': true}"
        >
          <a class="nav-link">
            <i class="mdi mdi-bulletin-board menu-icon"></i>
            <span class="menu-title">Transactions</span>
            <i class="menu-arrow"></i>
          </a>
          <div class="submenu">
            <ul class="submenu-item">
              <li class="nav-item">
                <a
                  class="nav-link"
                  (click)="router.navigate(['transactions/questionBank'])"
                  >Question Bank</a
                >
              </li>

              <li class="nav-item">
                <a
                  class="nav-link"
                  (click)="router.navigate(['transactions/trainingSchedule'])"
                  >Training Schedule</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  (click)="router.navigate(['transactions/trainingApproval'])"
                  >Training Approval</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  (click)="router.navigate(['transactions/trainingAttendanceApproval'])"
                  >Training Attendance Approval</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  (click)="router.navigate(['transactions/evaluation'])"
                  >Online Evaluation</a
                >
              </li>

              <li class="nav-item">
                <a
                  class="nav-link"
                  (click)="router.navigate(['transactions/offlineEvaluation'])"
                  >Offline Evaluation</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  (click)="router.navigate(['transactions/hodFeedback'])"
                  >HOD Feedback</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  (click)="router.navigate(['transactions/hrFeedback'])"
                  >HR Feedback</a
                >
              </li>
            </ul>
          </div>
        </li>
        <!-- <li class="nav-item">
          <a class="nav-link">
            <i class="mdi mdi-file-document-box-outline menu-icon"></i>
            <span class="menu-title">Reports</span></a
          >
        </li> -->
        <li
          (click)="toggleSubmenuReports()"
          [ngClass]="{'show-submenu' : submenuReports, 'nav-item': true}"
        >
          <a class="nav-link">
            <i class="mdi mdi-file-document-box-outline menu-icon"></i>
            <span class="menu-title">Reports</span>
            <i class="menu-arrow"></i>
          </a>
          <div class="submenu" style="right: 0; left: auto;">
            <ul class="submenu-item">
              <li class="nav-item">
                <a
                  class="nav-link"
                  (click)="router.navigate(['reports/historyCard'])"
                  >Effectivness Of Training</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  (click)="router.navigate(['reports/employeeHistoryCard'])"
                  >Employee History Card</a
                >
              </li>

              <li class="nav-item">
                <a
                  class="nav-link"
                  (click)="router.navigate(['reports/presentSkills'])"
                  >Present Skills</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  (click)="router.navigate(['reports/trainingNeeds'])"
                  >Training Needs</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  (click)="router.navigate(['reports/trainingCalender'])"
                  >Training Calender</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  (click)="router.navigate(['reports/trainingAttendanceReport'])"
                  >Training Attendance</a
                >
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</div>
